import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import AdvancedTypography from 'Components/UI/AdvancedTypography';
import { FDStack } from '@facet-wealth/design';

const Layout = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <FDStack spacing={2} direction={'column'}>
      <AdvancedTypography
        fragments={[
          {
            text: 'Assume that ',
          },
          {
            color: 'black',
            weight: 'bold',
            text: `${resource.attr('remainingCashOnHandSpent')}%`,
          },
          {
            text: ' of excess monthly cash is spent.',
          },
        ]}
        variant="h6"
      />
      <MetaControlField attr={'remainingCashOnHandSpent'} />
    </FDStack>
  );
};

export default Layout;
